import { Circle } from '@components/icons'
import ListItem from './ListItem'
interface Props {
  slice: any
}

const ChecklistBlock = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const description = slice?.primary?.description
  const imageUrl1 = slice?.primary?.image1?.url
  const imageAlt1 = slice?.primary?.image1?.alt
  const link1 = slice?.primary?.link1
  const imageUrl2 = slice?.primary?.image2?.url
  const imageAlt2 = slice?.primary?.image2?.alt
  const link2 = slice?.primary?.link2
  const imageUrl3 = slice?.primary?.image3?.url
  const imageAlt3 = slice?.primary?.image3?.alt
  const link3 = slice?.primary?.link3
  const checklistItems = slice?.items
  const productList = [
    { url: imageUrl1, alt: imageAlt1, link: link1 },
    { url: imageUrl2, alt: imageAlt2, link: link2 },
    { url: imageUrl3, alt: imageAlt3, link: link3 },
  ]
  return (
    <div className="grid grid-cols-4 gap-x-6 gap-y-10 pt-18 pb-10 lg:grid-cols-12 lg:gap-x-8 lg:gap-y-0 lg:pt-40 lg:pb-20">
      <div className="col-span-4 flex flex-col justify-between lg:col-span-3 lg:gap-y-2">
        <div className="flex flex-col gap-2 lg:gap-4">
          {title && <div className="heading-4">{title}</div>}
          {description && <div className="body-1">{description}</div>}
        </div>
        <div className="pt-6 lg:pt-0">
          {checklistItems &&
            checklistItems.map((item: any, index: number) => {
              return (
                <div key={index} className="body-1 flex gap-3">
                  <Circle />
                  {item.checklist_item}
                </div>
              )
            })}
        </div>
      </div>
      <div className="col-span-4 grid auto-cols-[19.75%] grid-flow-col gap-x-6 overflow-x-scroll pb-9 scrollbar-hide lg:hidden">
        {productList.map((item, index) => {
          return <ListItem key={index} item={item} />
        })}
      </div>
      <div className="col-span-4 hidden grid-cols-9 gap-x-8 lg:col-span-9 lg:grid">
        {productList.map((item, index) => {
          return <ListItem key={index} item={item} />
        })}
      </div>
    </div>
  )
}

export default ChecklistBlock
